import { motion } from "motion/react"

interface TypingIndicatorProps {
  className?: string
  dotClassName?: string
}

export default function TypingIndicator({
  className = "",
  dotClassName = "h-2 w-2 rounded-full bg-gray-400",
}: TypingIndicatorProps) {
  return (
    <div className={`inline-flex items-center gap-1 ${className}`}>
      <motion.span
        className={dotClassName}
        animate={{ opacity: [0.35, 1, 0.35], scale: [0.8, 1, 0.8] }}
        transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.span
        className={dotClassName}
        animate={{ opacity: [0.35, 1, 0.35], scale: [0.8, 1, 0.8] }}
        transition={{
          duration: 1.4,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0.2,
        }}
      />
      <motion.span
        className={dotClassName}
        animate={{ opacity: [0.35, 1, 0.35], scale: [0.8, 1, 0.8] }}
        transition={{
          duration: 1.4,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0.4,
        }}
      />
    </div>
  )
}
